import './DoubleColumnA.scss';

import { b2x } from '@b2x/react/src';
import classNames from 'classnames';

import { Container } from '../Container';

export interface DoubleColumnAContentType {
  asset?: b2x.contentTypes.AssetContentSectionV2;
  copy?: {
    content?: string;
    cta?: b2x.contentTypes.CtaContentSection;
    options?: {
      size?: string;
      textAlign?: string;
    };
    pretitle?: string;
    title?: string;
  };
  options?: {
    background?: string;
    ordering?: {
      desktop?: string;
      mobile?: string;
    };
  };
}

interface DoubleColumnAProps extends DoubleColumnAContentType {
  mainComponent?: boolean;
}

export const DoubleColumnA = ({ asset, copy, mainComponent, options }: DoubleColumnAProps) => {
  const { getPagePath } = b2x.useAppStaticContext();

  const copyColumnSize: b2x.ColSize = copy?.options?.size === 'small' ? 4 : copy?.options?.size === 'large' ? 8 : 6;
  const desktopBehavior = `desktop-${options?.ordering?.desktop?.replace(' ', '-')}`;
  const mobileBehavior = `mobile-${options?.ordering?.mobile?.replace(' ', '-')}`;

  const textAlign: b2x.TextAlign =
    copy?.options?.textAlign === 'center' ? 'center' : copy?.options?.textAlign === 'end' ? 'end' : 'start';

  return (
    <Container fluid="always">
      <b2x.Div
        background={options?.background}
        className={'double-column-a'}
        marginBottom={undefined}
        paddingX={{ md: 4, xs: 0 }}
        paddingY={{ md: 5 }}
      >
        <Container>
          <b2x.Div className={classNames(desktopBehavior, mobileBehavior)}>
            <b2x.Row>
              <b2x.Col className={'copy-column'} display={'flex'} size={{ md: copyColumnSize, xs: 12 }}>
                <b2x.Div
                  alignItems={'center'}
                  display={'flex'}
                  paddingY={{ md: 0, xs: 5 }}
                  style={{ height: '100%' }}
                  textAlign={{ md: textAlign, xs: 'center' }}
                >
                  <b2x.Div>
                    {copy?.pretitle && (
                      <b2x.P
                        className="pretitle letter-spacing-md small"
                        marginBottom={2}
                        textAlign={{ md: textAlign, xs: 'center' }}
                      >
                        {b2x.formatHtml(copy.pretitle)}
                      </b2x.P>
                    )}
                    <b2x.ConditionalWrapper
                      condition={copy?.title !== undefined}
                      wrapper={
                        mainComponent ? (
                          <b2x.H1 className="title" fontWeight={700} textAlign={{ md: textAlign, xs: 'center' }} />
                        ) : (
                          <b2x.P className="title h1" fontWeight={700} textAlign={{ md: textAlign, xs: 'center' }} />
                        )
                      }
                    >
                      {b2x.formatHtml(copy?.title)}
                    </b2x.ConditionalWrapper>
                    {copy?.content && <b2x.H4 className="content">{b2x.formatHtml(copy.content)}</b2x.H4>}
                    {copy?.cta && <b2x.CtaFromContent {...copy.cta} />}
                  </b2x.Div>
                </b2x.Div>
              </b2x.Col>
              {asset?.type && (
                <b2x.Col className="asset-column" size={{ md: '', xs: 12 }}>
                  <b2x.ConditionalWrapper
                    condition={copy?.cta !== undefined}
                    wrapper={
                      <b2x.router.Link
                        to={copy?.cta?.to?.href ? copy.cta.to.href : copy?.cta?.to?.code && getPagePath(copy.cta.to.code)}
                      />
                    }
                  >
                    <b2x.AssetV2 {...asset} fluid />
                  </b2x.ConditionalWrapper>
                </b2x.Col>
              )}
            </b2x.Row>
          </b2x.Div>
        </Container>
      </b2x.Div>
    </Container>
  );
};
